import Alpine from "alpinejs";
import { dispatch } from "../utils/events.ts";
import { IContextMenuItem } from "../global";

function collectMenuItems(startEl: HTMLElement, ownExpression: string): IContextMenuItem[] {
  const groups: { priority: number; items: IContextMenuItem[] }[] = [];
  const isError = startEl.hasAttribute("data-error-kind");
  groups.push({ priority: isError ? 1 : 0, items: JSON.parse(ownExpression) });

  let parent = startEl.parentElement;
  while (parent) {
    const attr = parent.getAttribute("x-context-menu-activate");
    if (attr) {
      const pIsError = parent.hasAttribute("data-error-kind");
      groups.push({ priority: pIsError ? 1 : 0, items: JSON.parse(attr) });
    }
    parent = parent.parentElement;
  }

  groups.sort((a, b) => b.priority - a.priority);

  const seen = new Set<string>();
  const merged: IContextMenuItem[] = [];
  for (const group of groups) {
    for (const item of group.items) {
      if (!seen.has(item.display)) {
        seen.add(item.display);
        merged.push(item);
      }
    }
  }
  return merged;
}

const contextMenuActivate: Alpine.DirectiveCallback = (
  el,
  { expression },
  { cleanup }
) => {
  function handleContextMenu(e: MouseEvent) {
    e.preventDefault();
    dispatch("context-menu-activate", {
      source: e,
      items: collectMenuItems(el as HTMLElement, expression),
      el: el as HTMLElement,
    });
  }

  function handleClick(e: MouseEvent) {
    dispatch("context-menu-activate", {
      source: e,
      items: collectMenuItems(el as HTMLElement, expression),
      el: el as HTMLElement,
    });
  }

  el.addEventListener("click", handleClick);
  el.addEventListener("contextmenu", handleContextMenu);

  cleanup(() => {
    el.removeEventListener("click", handleClick);
    el.removeEventListener("contextmenu", handleContextMenu);
  });
};
export default contextMenuActivate;
